export default __webpack_public_path__ + "static/media/dr-consulta2.49b8c0e8.svg";